/* =========================================================
   MAISON AMAN — Personnaliser mon voile
   Controller: modèle/variantes, broderie checkboxes, SVG preview, récap
   ========================================================= */

(function () {
  'use strict';

  const FONT_MAP = {
    warm: "'Allura', cursive",
    montserrat: "'Montserrat', sans-serif",
    biryani: "'Biryani', sans-serif",
    distillery: "'Pinyon Script', cursive",
    bundt: "'Dancing Script', cursive",
  };

  function initPerso(root) {
    if (!root || root.dataset.maPersoInit) return;
    root.dataset.maPersoInit = '1';

    const freeFrom = root.dataset.freeFrom || '';
    const moneyFormat = root.dataset.moneyFormat || '{AMOUNT} €';
    const embroideryDefault = root.dataset.embroideryDefault || 'ma date brodée ici';

    const state = {
      modelName: '',
      basePrice: 0,
      structure: '',
      font: 'warm',
      broderie: {
        initiales: { active: false, value: '', price: 60, label: 'Initiales' },
        prenoms: { active: false, value: '', price: 90, label: 'Prénoms' },
        date: { active: false, value: '', price: 90, label: "Date d'union" },
        phrase: { active: false, value: '', price: 150, label: 'Phrase personnalisée' },
      },
    };

    const previewImg = root.querySelector('[data-preview-image]');
    const embroideryText = root.querySelector('.ma-perso__embroidery');
    const previewWrap = root.querySelector('[data-preview-wrap]');
    const recapLines = root.querySelector('.ma-perso__recap-lines');
    const recapTotal = root.querySelector('.ma-perso__recap-total-value');
    const mobileTotal = root.querySelector('.ma-perso__mobile-total');
    const currentModelEl = root.querySelector('.ma-perso__current-model');
    const priceDateEl = root.querySelector('[data-price-display="date"]');
    const variantIdInput = root.querySelector('[data-variant-id-input]');
    const propertiesContainer = root.querySelector('[data-properties-container]');
    const mainForm = root.querySelector('form[action*="/cart/add"]');

    function formatPrice(amount) {
      return moneyFormat.replace('{AMOUNT}', amount.toString());
    }

    function todayYmd() {
      const d = new Date();
      return d.toISOString().slice(0, 10);
    }

    function isDateOffered() {
      if (!freeFrom) return false;
      return todayYmd() >= freeFrom;
    }

    function updateDatePriceDisplay() {
      if (!priceDateEl) return;
      if (isDateOffered()) {
        priceDateEl.innerHTML =
          '<span class="strike">+' + formatPrice(state.broderie.date.price) + '</span>' +
          '<span class="offert">Offert</span>';
        priceDateEl.classList.add('ma-perso__broderie-price--free');
      } else {
        priceDateEl.textContent = '+' + formatPrice(state.broderie.date.price);
        priceDateEl.classList.remove('ma-perso__broderie-price--free');
      }
    }

    function parseStructureConfig(configStr) {
      const map = {};
      if (!configStr) return map;
      configStr.split('\n').forEach((line) => {
        const parts = line.trim().split('|');
        if (parts.length !== 2) return;
        const modelKey = parts[0].trim().toLowerCase();
        const structs = parts[1].split(',').map((s) => s.trim().toLowerCase());
        if (modelKey) map[modelKey] = structs;
      });
      return map;
    }

    const structureContainer = root.querySelector('.ma-perso__structure-options');
    const structureConfig = structureContainer
      ? parseStructureConfig(structureContainer.dataset.structureConfig || '')
      : {};

    function updateStructureAvailability(modelName) {
      if (!structureContainer) return;
      const key = (modelName || '').toLowerCase();
      const allowed = structureConfig[key];

      root.querySelectorAll('.ma-perso__structure-option').forEach((btn) => {
        const structureKey = (btn.dataset.structure || '').toLowerCase();
        if (!allowed || allowed.includes(structureKey)) {
          btn.disabled = false;
          btn.classList.remove('is-disabled');
        } else {
          btn.disabled = true;
          btn.classList.remove('is-active');
          btn.classList.add('is-disabled');
        }
      });

      // If active structure became disabled, switch to first available
      const activeBtn = structureContainer.querySelector('.ma-perso__structure-option.is-active');
      if (!activeBtn || activeBtn.disabled) {
        const firstAvailable = structureContainer.querySelector('.ma-perso__structure-option:not([disabled])');
        if (firstAvailable) {
          firstAvailable.classList.add('is-active');
          state.structure = firstAvailable.dataset.structure || '';
        }
      }
    }

    function setActiveModel(btn) {
      root.querySelectorAll('.ma-perso__model-swatch').forEach((b) =>
        b.classList.remove('is-active')
      );
      btn.classList.add('is-active');

      state.modelName = btn.dataset.modelName || '';
      state.basePrice = parseFloat(btn.dataset.price || '0');

      if (currentModelEl) currentModelEl.textContent = state.modelName;
      if (variantIdInput && btn.dataset.variantId) {
        variantIdInput.value = btn.dataset.variantId;
      }

      const newSrc = btn.dataset.image;
      if (newSrc && previewImg && previewImg.getAttribute('src') !== newSrc) {
        previewImg.style.transition = 'opacity 0.35s ease';
        previewImg.style.opacity = '0';
        const preloader = new Image();
        preloader.onload = function () {
          previewImg.setAttribute('src', newSrc);
          requestAnimationFrame(() => (previewImg.style.opacity = '1'));
        };
        preloader.src = newSrc;
      }

      updateStructureAvailability(state.modelName);
      renderRecap();
    }

    root.querySelectorAll('.ma-perso__model-swatch').forEach((btn) => {
      btn.addEventListener('click', () => setActiveModel(btn));
    });

    root.querySelectorAll('.ma-perso__structure-option').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('.ma-perso__structure-option').forEach((b) =>
          b.classList.remove('is-active')
        );
        btn.classList.add('is-active');
        state.structure = btn.dataset.structure || '';
      });
    });

    root.querySelectorAll('.ma-perso__broderie-option').forEach((option) => {
      const head = option.querySelector('.ma-perso__broderie-head');
      const check = option.querySelector('.ma-perso__broderie-check');
      const input = option.querySelector('[data-field]');
      const key = option.dataset.key;

      if (!key || !state.broderie[key]) return;

      head.addEventListener('click', (e) => {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
        e.preventDefault();
        state.broderie[key].active = !state.broderie[key].active;
        option.classList.toggle('is-active', state.broderie[key].active);
        if (check) check.checked = state.broderie[key].active;
        if (state.broderie[key].active && input) {
          setTimeout(() => input.focus(), 400);
        }
        renderRecap();
        updateEmbroideryText();
      });

      if (input) {
        input.addEventListener('input', (e) => {
          state.broderie[key].value = e.target.value;
          if (key === 'phrase') {
            const counter = root.querySelector('[data-phrase-count]');
            if (counter) {
              counter.textContent = e.target.value.length;
              counter.parentElement.classList.toggle('is-warn', e.target.value.length > 40);
            }
          }
          updateEmbroideryText();
        });
      }
    });

    root.querySelectorAll('.ma-perso__font-swatch').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('.ma-perso__font-swatch').forEach((b) =>
          b.classList.remove('is-active')
        );
        btn.classList.add('is-active');
        state.font = btn.dataset.font || 'warm';
        updateEmbroideryText();
      });
    });

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function updateEmbroideryText() {
      if (!embroideryText) return;
      const anyActive = Object.values(state.broderie).some((b) => b.active);

      if (!anyActive) {
        embroideryText.textContent = embroideryDefault;
        embroideryText.style.fontFamily = FONT_MAP[state.font] || FONT_MAP.warm;
        embroideryText.setAttribute('font-size', '28');
        embroideryText.setAttribute('y', '370');
        if (previewWrap) previewWrap.classList.remove('ma-perso--has-input');
        return;
      }

      if (previewWrap) previewWrap.classList.add('ma-perso--has-input');

      const parts = [];
      if (state.broderie.prenoms.active && state.broderie.prenoms.value) {
        parts.push(state.broderie.prenoms.value);
      } else if (state.broderie.initiales.active && state.broderie.initiales.value) {
        parts.push(state.broderie.initiales.value);
      }
      if (state.broderie.date.active && state.broderie.date.value) {
        parts.push(state.broderie.date.value);
      }
      if (state.broderie.phrase.active && state.broderie.phrase.value) {
        parts.push(state.broderie.phrase.value);
      }

      if (parts.length === 0) {
        if (state.broderie.prenoms.active) parts.push('Jean & Marie');
        if (state.broderie.initiales.active && !state.broderie.prenoms.active) parts.push('J & M');
        if (state.broderie.date.active) parts.push('15.06.2026');
        if (state.broderie.phrase.active) parts.push('pour toujours');
      }

      embroideryText.style.fontFamily = FONT_MAP[state.font] || FONT_MAP.warm;

      // Taille basée sur la ligne la plus longue
      const longestLen = Math.max.apply(null, parts.map((p) => p.length));
      let size = 32;
      if (longestLen > 15) size = 28;
      if (longestLen > 25) size = 22;
      if (longestLen > 40) size = 18;
      embroideryText.setAttribute('font-size', size);

      // Décale le Y de départ vers le haut en fonction du nombre de lignes
      // pour que le bloc de broderie reste visuellement centré.
      const baseY = 370;
      const lineHeightEm = 1.25;
      const offsetY = baseY - ((parts.length - 1) * size * lineHeightEm) / 2;
      embroideryText.setAttribute('y', offsetY);

      // Empile chaque partie sur sa propre ligne
      const tspans = parts.map((part, i) => {
        const isPhrase = state.broderie.phrase.active
          && state.broderie.phrase.value
          && i === parts.length - 1
          && parts.length > 1
          && part === state.broderie.phrase.value;
        const dy = i === 0 ? '0' : lineHeightEm + 'em';
        if (isPhrase) {
          return '<tspan x="360" dy="' + dy + '" font-style="italic" font-size="' +
            (size - 4) + '">« ' + escapeHtml(part) + ' »</tspan>';
        }
        return '<tspan x="360" dy="' + dy + '">' + escapeHtml(part) + '</tspan>';
      });

      embroideryText.innerHTML = tspans.join('');
    }

    function renderRecap() {
      if (!recapLines) return;
      let total = state.basePrice;
      const rows = [];

      rows.push(
        '<li class="ma-perso__recap-line">' +
          '<span class="ma-perso__recap-line-label">Voile <em>' + escapeHtml(state.modelName) + '</em></span>' +
          '<span class="ma-perso__recap-line-price">' + formatPrice(state.basePrice) + '</span>' +
        '</li>'
      );

      Object.entries(state.broderie).forEach(([key, b]) => {
        if (!b.active) return;
        const isDateFree = key === 'date' && isDateOffered();
        const linePrice = isDateFree ? 0 : b.price;
        total += linePrice;

        if (isDateFree) {
          rows.push(
            '<li class="ma-perso__recap-line ma-perso__recap-line--free">' +
              '<span class="ma-perso__recap-line-label">+ ' + escapeHtml(b.label) + '</span>' +
              '<span class="ma-perso__recap-line-price">' +
                '<span class="strike">' + formatPrice(b.price) + '</span>Offert' +
              '</span>' +
            '</li>'
          );
        } else {
          rows.push(
            '<li class="ma-perso__recap-line">' +
              '<span class="ma-perso__recap-line-label">+ ' + escapeHtml(b.label) + '</span>' +
              '<span class="ma-perso__recap-line-price">' + formatPrice(b.price) + '</span>' +
            '</li>'
          );
        }
      });

      recapLines.innerHTML = rows.join('');
      if (recapTotal) recapTotal.textContent = formatPrice(total);
      if (mobileTotal) mobileTotal.textContent = formatPrice(total);
    }

    /* ----- Add-on broderie variant IDs ----- */
    const BRODERIE_VARIANTS = {
      initiales: { variantId: 54765433749772, label: 'Broderie · Initiales' },
      prenoms:   { variantId: 54765443907852, label: 'Broderie · Prénoms' },
      date:      {
        variantIdPaid: 54765455048972,
        variantIdFree: 54765455081740,
        label: 'Broderie · Date d\'union',
      },
      phrase:    { variantId: 54765446725900, label: 'Broderie · Phrase personnalisée' },
    };

    const FONT_LABELS = {
      warm: 'Warm script',
      montserrat: 'Montserrat',
      biryani: 'Biryani',
      distillery: 'Distillery script',
      bundt: 'Bundt cake',
    };

    function getFontLabel() {
      return FONT_LABELS[state.font] || state.font;
    }

    function buildVoileProperties() {
      const props = {};
      if (state.structure) props['Structure'] = state.structure;
      // Les détails broderie (prénom, date, phrase, police) sont affichés
      // sur les lignes add-on, pas ici — pour éviter les doublons au panier.
      return props;
    }

    async function handleAddToCart(e) {
      if (e) e.preventDefault();

      const voileVariantId = variantIdInput ? variantIdInput.value : null;
      if (!voileVariantId) return;

      const groupId = 'voile-' + Date.now();
      const voileProps = buildVoileProperties();
      voileProps['_group'] = groupId;

      // Build addons first, then voile last (Shopify affiche les items
      // dans l'ordre inverse d'ajout → voile en tête, broderies en dessous)
      const items = [];

      Object.entries(state.broderie).forEach(([key, b]) => {
        if (!b.active) return;
        const cfg = BRODERIE_VARIANTS[key];
        if (!cfg) return;

        let variantId;
        if (key === 'date') {
          variantId = isDateOffered() ? cfg.variantIdFree : cfg.variantIdPaid;
        } else {
          variantId = cfg.variantId;
        }

        const value = b.value || '(à préciser)';
        items.push({
          id: variantId,
          quantity: 1,
          properties: {
            '_group': groupId,
            '_addon_for': 'Voile',
            'Détail': value,
            'Police': getFontLabel(),
          },
        });
      });

      // Voile ajouté en dernier → apparaîtra en haut du panier
      items.push({
        id: parseInt(voileVariantId, 10),
        quantity: 1,
        properties: voileProps,
      });

      const cartDrawer = document.querySelector('cart-drawer');
      const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((s) => s.id).join(',')
        : 'cart-drawer,cart-icon-bubble';

      try {
        let lastResponse = null;

        // Add items one by one (simpler error handling + preserved order)
        for (const item of items) {
          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('quantity', item.quantity);
          Object.entries(item.properties || {}).forEach(([k, v]) => {
            formData.append('properties[' + k + ']', v);
          });
          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
            body: formData,
          });

          const json = await res.json().catch(() => ({}));

          if (!res.ok || json.status) {
            console.error('[ma-perso] cart/add failed for item', item, 'response:', json);
            alert('Erreur lors de l\'ajout au panier (variant ' + item.id + '). ' + (json.description || json.message || ''));
            return;
          }
          lastResponse = json;
        }

        // Re-render cart drawer with the last response (contains fresh sections HTML)
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && lastResponse) {
          // Retire la classe is-empty du drawer si le panier était vide avant
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(lastResponse);
          // Sécurité : re-retire après render (Dawn n'enlève is-empty que sur .drawer__inner)
          setTimeout(() => cartDrawer.classList.remove('is-empty'), 50);
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('[ma-perso] cart/add exception', err);
        alert('Erreur lors de l\'ajout au panier.');
      }
    }

    if (mainForm) mainForm.addEventListener('submit', handleAddToCart);

    const mobileCta = root.querySelector('[data-mobile-cta]');
    if (mobileCta) {
      mobileCta.addEventListener('click', handleAddToCart);
    }

    const defaultModel = root.querySelector('.ma-perso__model-swatch.is-active') ||
                         root.querySelector('.ma-perso__model-swatch');
    if (defaultModel) setActiveModel(defaultModel);

    updateDatePriceDisplay();
    updateEmbroideryText();
    renderRecap();
  }

  function bootAll() {
    document.querySelectorAll('[data-ma-perso]').forEach(initPerso);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-ma-perso]');
    if (root) initPerso(root);
  });
})();
